import { render, staticRenderFns } from "./VMilestones.vue?vue&type=template&id=67c9a8db&"
import script from "./VMilestones.vue?vue&type=script&lang=js&"
export * from "./VMilestones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports